import React from 'react';
import { Route, Switch } from 'react-router-dom';

import StaffTable from '../../components/StaffTable';
import StaffView from '../../components/StaffView';

const Staffs = ({ match }) => {
  return (
    <div>
      <Switch>
        <Route
          path={match.url}
          exact
          render={(props) => {
            return <StaffTable {...props} />;
          }}
        />
        <Route
          path={`${match.url}/:Id`}
          exact
          render={(props) => {
            return <StaffView {...props} />;
          }}
        />
      </Switch>
    </div>
  );
};

export default Staffs;
